@if (this.order) {
  <div (click)="this.close($event)"
    class="modal bg-black/50 flex items-center justify-center overflow-hidden clickClose p-2"
    style="z-index: 999; position: fixed">
    <div class="bg-white w-full h-fit max-h-[650px] max-w-[1000px] rounded flex flex-col fadeIn p-2">
      <div class="w-full p-3 relative flex items-start items-center gap-2">
        <div class="p-2 rounded bg-vert-3">
          <svg class="fg-vert-1 w-6 h-6 text-lg">
            <use href="/assets/images/icons/icons.svg#service"></use>
          </svg>
        </div>
        <p class="font-bold fg-noir-1">Noter la commande du {{this.formatDate(this.order.deliveryDate)}}</p>
      </div>
      <div class="flex-1 overflow-y-auto">
        <table class="w-full">
          <tr class="border-bottom-1 border-gris-3">
            <th class="px-4 text-left py-4 fg-gris-1 font-bold text-sm px-1">Plat</th>
            <th class="text-center py-4 fg-gris-1 font-bold text-sm px-1">Note</th>
            <th class="text-center py-4 fg-gris-1 font-bold text-sm px-1">Commentaire</th>
          </tr>
          @for (orderItem of order?.orderItems; track orderItem) {
            <tr class="border-bottom-1 border-gris-3">
              <td class="px-2 py-2">
                <span class="w-3/4 block fg-noir-1 text-sm font-medium" [innerText]="orderItem.serviceContent">
                </span>
              </td>
              <td class="px-2 py-2">
                <mk-star-notation #courseNote [attr.data-course]="JSON.stringify(orderItem)" [maxStars]="5" />
              </td>
              <td class="px-2 py-2">
                <mk-text-input #courseComment  [attr.data-course]="JSON.stringify(orderItem)" type="text" textAlign="left" placeholder="Laisser un commentaire ?" displayQtyBtn="false" classes="text-xs" class="border-none"/>
              </td>
            </tr>
          }
        </table>
      </div>
      <div class="w-full flex justify-center py-2">
        <mk-green-action-button [data]="this" [enabled]="true" baseIcon="check" baseLabel="Noter la commande" class="h-12 w-[16rem]" [callback]="this._handler_note"/>
      </div>
    </div>
  </div>
}
